export default "__VITE_ASSET__BGfTz$fR__"